// removed by extract-text-webpack-plugin
module.exports = {"header":"src-components----header-module---header---2Q3RK","icon":"src-components----header-module---icon---1gOzA","nav":"src-components----header-module---nav---3m-_Y","linkStyle":"src-components----header-module---linkStyle---2tnMX","footer":"src-components----header-module---footer---3tIW8","iconflex":"src-components----header-module---iconflex---2TWTA"};


//////////////////
// WEBPACK FOOTER
// ./src/components/header.module.css
// module id = 171
// module chunks = 168707334958949